import React, { useState } from 'react';
import './WaitlistForm.css';

function WaitlistForm({ onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    companySize: '',
    lookingFor: '',
    referralSource: ''
  });
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSdhevF9gniAHJbRX2osUQ4SYQL62BtnR47_4ihYD9oeL0Hobg/formResponse';
    
    const form = new FormData();
    form.append('entry.79223828', formData.name);
    form.append('entry.26082454', formData.email);
    form.append('entry.1630118070', formData.website);
    form.append('entry.1733666436', formData.companySize === '1-10' ? '1-10 employees' : 
                                   formData.companySize === '11-50' ? '11-50 employees' :
                                   formData.companySize === '51-200' ? '51-200 employees' :
                                   formData.companySize === '201-500' ? '201-500 employees' :
                                   formData.companySize === '500+' ? '500+ employees' : '');
    form.append('entry.1228675111', formData.lookingFor);
    form.append('entry.328588238', formData.referralSource);

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: form
      });
      setStatus('success');
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus('error');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="waitlist-modal">
      <div className="waitlist-modal-content">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Request Early Access</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              required
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Work Email *"
              required
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <input
              type="url"
              name="website"
              placeholder="Company Website *"
              required
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <select name="companySize" required onChange={handleChange}>
              <option value="">Company Size *</option>
              <option value="1-10">1-10 employees</option>
              <option value="11-50">11-50 employees</option>
              <option value="51-200">51-200 employees</option>
              <option value="201-500">201-500 employees</option>
              <option value="500+">500+ employees</option>
            </select>
          </div>
          <div className="form-group">
            <textarea
              name="lookingFor"
              placeholder="What are you looking for? *"
              required
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="referralSource"
              placeholder="How did you hear about us?"
              onChange={handleChange}
            />
          </div>
          <button 
            type="submit" 
            className="submit-button"
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Submitting...' : 'Submit Request'}
          </button>
        </form>
        
        {status === 'success' && (
          <div className="success-message">
            Thanks for your interest! We'll be in touch soon.
          </div>
        )}
        
        {status === 'error' && (
          <div className="error-message">
            Something went wrong. Please try again.
          </div>
        )}
      </div>
    </div>
  );
}

export default WaitlistForm; 